import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: `${process.env.VUE_APP_TEAMS_CLIENT_ID}`, // this can stay the same
    authority: `${process.env.VUE_APP_TEAMS_AUTHORITY}`, // ✅ <--- Set your required tenant here
    redirectUri: `${process.env.VUE_APP_TEAMS_REDIRECT_URI}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();
// await msalInstance.acquireTokenSilent({ scopes: ["OnlineMeetings.ReadWrite"] })

export default msalInstance;

